import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './api/setupAxios';
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import { Provider } from 'react-redux'
import store from './redux/store/store';

import { ChakraProvider } from '@chakra-ui/react'
import NoPage from './component/page/noPage/noPage';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';  // <-- Добавьте эту строку
// В самом начале index.js или axios.js
import axios from "axios";
import CsrfProvider from './CsrfProvider';
import { captureAttributionFromLocation } from './component/aouth/referral/attributionStorage';

// react-pdf в приложении не используется (PDF показывает @react-pdf-viewer в окне оферты),
// поэтому его импорт ради настройки воркера убран: он тянул pdf.js в основную сборку.

// Метки рекламного перехода (utm_*, yclid) запоминаем до любых редиректов приложения,
// чтобы они дошли до регистрации нового номера.
captureAttributionFromLocation(window.location.search);

axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  console.log("withCredentials?", config.withCredentials); // должно быть true
  return config;
});



const theme = {
  fontSizes: {
    lg: '18px',
  },
  colors: {
    gray: {
      100: '#fafafa',
      200: '#f7f7f7',
    },
  },
}



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

<React.StrictMode>
  <HelmetProvider>
    <BrowserRouter>
    <Provider store={store}>
    <CsrfProvider />
      <ChakraProvider>
        <App />
      </ChakraProvider>
    </Provider>
  </BrowserRouter>
  </HelmetProvider>

</React.StrictMode>
);

serviceWorkerRegistration.register();
